// removed by extract-text-webpack-plugin
module.exports = {"root":"home--root--2GxApsb7 organization-home--root--29mpR9MJ","grid-container":"home--grid-container--1c07VAom home--grid-container--3c3JLjRI","gridContainer":"home--grid-container--1c07VAom home--grid-container--3c3JLjRI","message":"home--message--2u0wtaZI home--message--9FSspPIv"};


//////////////////
// WEBPACK FOOTER
// ./views/lado-a-lado/dealer/home/styles.css
// module id = ./views/lado-a-lado/dealer/home/styles.css
// module chunks = 0